<template>
  <section class="notFoundCnt">
    <Header :class="{scrolled: isScrolled}" ref="header"/>
    <div class="loadingLanguage" v-if="loadingLang"></div>
    <div class="notFound" v-else>
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2>404 | {{lang.langs.not_found_title.value}}</h2>
      <p>{{lang.langs.not_found_desc.value}}</p>
      <a href="/">{{lang.langs.back_to_home.value}}</a>
    </div>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'notFound',
  components: { Header, Footer },
  data() {
    return {
      isScrolled: false,

      /**
       * Language
       *
       */
      loadingLang: true,
      lang: null,
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  methods: {
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
  },
  mounted() {
    let lang = localStorage.getItem('portal_putusan_penting_icel_lang');
    if (!lang) lang = window.navigator.userLanguage || window.navigator.language;
    if (lang === 'en-US' || lang === 'en') lang = 'en';
    else if (lang === 'id-ID' || lang === 'id') lang = 'id';
    else lang = 'id';
    this.$http.get(this.$config.uri(`misc/lang/${lang}`)).then((rlang) => {
      this.loadingLang = false;
      this.lang = rlang.data.data;
    });
  },
};
</script>

<style scoped lang="scss">
.notFoundCnt{
  position: relative;
  height: 100vh;
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 500px;
      margin-bottom: 40px;
      display: none;
    }
    h2{
      margin: 0 0 4px;
      font-size: 30px;
      line-height: 1;
      font-size: 20px;
      margin: 0 0 10px;
    }
    h4{
      margin: 0;
      font-size: 50px;
      line-height: 1;
      display: none;
    }
    p{
      margin: 0 0 20px;
      font-size: 15px;
    }
    a{
      border-radius: 5px;
      border: #ccc 1px solid;
      padding: 10px 20px;
      display: inline-block;
    }
  }
}
</style>
